import React from 'react';
import { MainView, GoalsDepCompleted, SingleDataContainer, HorizontalContainer, WhatOthers } from '../components/components.js';
import StringUtils from '../utils/stringutils.js';

class Goals extends React.Component {

	render() {
		if(!window._fiSponsor.sponsors.length) {
			window._fiSponsor.loadSessionInfo();
		}
		
		var content = (
			<p>Content not found</p>
			);
		const depGrowthContainerSize = {
			width : '50vmin',
		    height: '74vmin'
		};

    const goaldetsContainerHeight = '105vmin';

		const avgGoalContainerSize = {
			width : '25vmin',
		  	height: '23vmin'
		};

		const horizGoalContainerSize = {
			width: '55vmin',
			height: '20vmin'
		};

    const whatOthersSize = {
      width: '55vmin',
      height: '32vmin'
    };
		
		const bgColor = 'rgb(100, 160, 67)';
		/*	              	<AverageAmount size={avgGoalContainerSize} />
	              	<AverageLength size={avgGoalContainerSize} />
	              		              	<HorizontalContainer title={'Averages'} apiCall={this._fiSponsor.getGoalsAverages} size={horizGoalContainerSize} />*/

		/*
props needed
label
addClass (optional)
bgcolor
size (optional)
icon_src
icon_alt
formatData(data)
objectToCall
apiCall(cb)
*/

		const formatDataAmount = function(data) {
			return StringUtils.dollar_format(data.max_amount, true);
		};

		const formatDataLength = function(data) {
			return data.max_length + ' months';
		};

	  	content = (
	  		<div className="App-ChartsBoxes">
	            <div className="App-ChartsBoxRow1">
	              	<GoalsDepCompleted size={depGrowthContainerSize} />
	              	<div className="App-ChartsBoxCol1 space-between BotPad" style={{height: goaldetsContainerHeight}}>
		              	<HorizontalContainer title={'Totals'} objectToCall={window._fiSponsor} apiCall={'getGoalsTotals'} size={horizGoalContainerSize} />
		              	<HorizontalContainer title={'Averages'} objectToCall={window._fiSponsor} apiCall={'getGoalsAverages'} size={horizGoalContainerSize} />
	              		<div className="App-ChartsBoxSubRow1 space-between">
	              			<SingleDataContainer label={'Largest goal amount'} objectToCall={window._fiSponsor} apiCall={'getGoalsMaximums'} size={avgGoalContainerSize}
	              				bgcolor={bgColor} icon_src={'max_amount.png'} icon_alt={'Money Bag'} formatData={formatDataAmount} />
	              			<SingleDataContainer label={'Longest goal'} objectToCall={window._fiSponsor} apiCall={'getGoalsMaximums'} size={avgGoalContainerSize}
	              				bgcolor={bgColor} icon_src={'max_time.png'} icon_alt={'Clock'} formatData={formatDataLength} />
	              		</div>
                    <WhatOthers title={'What Users are Saving For'} pagesize={3} size={whatOthersSize} />
	              	</div>
	            </div>
	         </div>
	  	);


		return (
			<MainView location={['Dashboard', 'Goals']} amount={window._fiSponsor.sponsors[0].total_saved} content={content} />
		);
  	}
}


export default Goals;